var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-base section-container-padding no-padding-left"},[_c('recipe-menu',{attrs:{"recipeLibrary":_vm.recipeLibrary}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }